/* Cart drawer upsell slider — global delegated handlers, survives cart-drawer re-renders */
(function () {
  if (window.__cdUpsellInit) return;
  window.__cdUpsellInit = true;

  function cdUpsellStep(track) {
    var first = track.querySelector('li');
    var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 12, 10);
    return first ? first.offsetWidth + gap : track.clientWidth * 0.5;
  }

  function cdUpsellUpdate(slider) {
    if (!slider) return;
    var track = slider.querySelector('[data-cd-upsell-track]');
    var prev = slider.querySelector('[data-cd-upsell-prev]');
    var next = slider.querySelector('[data-cd-upsell-next]');
    if (!track || !prev || !next || track.clientWidth === 0) return;
    var max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = max <= 1 || track.scrollLeft >= max - 1;
  }

  function cdUpsellUpdateAll() {
    document.querySelectorAll('[data-cd-upsell-slider]').forEach(cdUpsellUpdate);
  }
  window.cdUpsellUpdateAll = cdUpsellUpdateAll;

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-cd-upsell-prev]');
    var next = e.target.closest('[data-cd-upsell-next]');
    var btn = prev || next;
    if (!btn) return;
    var slider = btn.closest('[data-cd-upsell-slider]');
    if (!slider) return;
    var track = slider.querySelector('[data-cd-upsell-track]');
    if (!track) return;
    var dir = prev ? -1 : 1;
    track.scrollBy({ left: dir * cdUpsellStep(track), behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.matches || !track.matches('[data-cd-upsell-track]')) return;
    cdUpsellUpdate(track.closest('[data-cd-upsell-slider]'));
  }, true);

  window.addEventListener('resize', cdUpsellUpdateAll);

  function attachDrawerObserver() {
    var drawer = document.querySelector('cart-drawer.drawer, .drawer');
    if (!drawer) return false;
    new MutationObserver(function () {
      setTimeout(cdUpsellUpdateAll, 60);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    return true;
  }

  if (!attachDrawerObserver()) {
    document.addEventListener('DOMContentLoaded', attachDrawerObserver);
  }

  setTimeout(cdUpsellUpdateAll, 100);

  /* ---------------------------------------------------------------------
     Quick-add modal handler (shared with main-product's pairs_with).
     Loaded here so the cart drawer's upsell modals open on every page,
     not just product pages. Idempotent via window.__pairsWithModalInit. */
  if (!window.__pairsWithModalInit) {
    window.__pairsWithModalInit = true;

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-pairs-open]');
      if (openBtn) {
        var dlg = document.getElementById(openBtn.getAttribute('data-pairs-open'));
        if (dlg && typeof dlg.showModal === 'function') {
          dlg.showModal();
        } else if (dlg) {
          dlg.setAttribute('open', '');
        }
        return;
      }
      var closeBtn = e.target.closest('[data-pairs-modal-close]');
      if (closeBtn) {
        var ownDlg = closeBtn.closest('dialog');
        if (ownDlg) ownDlg.close();
        return;
      }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('pairs-modal')) {
        e.target.close();
        return;
      }
      var qm = e.target.closest('[data-pairs-qty-minus]');
      if (qm) {
        var iMinus = qm.parentElement.querySelector('input[name="quantity"]');
        if (iMinus) iMinus.value = Math.max(parseInt(iMinus.min || '1', 10), (parseInt(iMinus.value, 10) || 1) - 1);
        return;
      }
      var qp = e.target.closest('[data-pairs-qty-plus]');
      if (qp) {
        var iPlus = qp.parentElement.querySelector('input[name="quantity"]');
        if (iPlus) iPlus.value = (parseInt(iPlus.value, 10) || 1) + 1;
        return;
      }
    });

    /* Close the modal after product-form's add-to-cart fetch completes */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('pairs-modal__form')) return;
      var dlg = form.closest('dialog.pairs-modal');
      if (!dlg) return;
      setTimeout(function () { dlg.close(); }, 700);
    });
  }

  /* Stop change events inside the quick-add modal from bubbling up to
     <cart-drawer-items> / <cart-items>, whose delegated handler runs
     validateQuantity() against the wrong target (the variant <select> or
     the modal's qty input) and shows "increments of undefined".
     Registered OUTSIDE the __pairsWithModalInit guard because that flag
     may have been set by main-product.liquid before this file loads. */
  if (!window.__pairsWithModalChangeGuard) {
    window.__pairsWithModalChangeGuard = true;
    document.addEventListener('change', function (e) {
      var modal = e.target && e.target.closest && e.target.closest('dialog.pairs-modal');
      if (modal) e.stopPropagation();
    }, true);
  }
})();
